import { InfoTooltipIcon } from "./InfoTooltipIcon"

export const ContributorsInfoTooltipIcon = () => {
  return <InfoTooltipIcon label="Kontaktpersonen(e) sender inn data på vegne av virksomheten som bærekraftmåles." />
}
